import { FC, forwardRef, useState } from 'react';
import { Box, Input } from '@base-app';
import { InputPasswordProps } from './InputPassword.types';
import {
  DescriptionStyled,
  FlexBoxStyled,
  VisibilityContainerStyled,
  VisibilityIconStyled,
  VisibilityOffIconStyled,
} from './InputPassword.styles';
import { inputWidth } from '@common/utils';

const InputPassword: FC<InputPasswordProps> = forwardRef<HTMLInputElement, InputPasswordProps>((props, ref) => {
  const { description, error, fullWidth, id, width, ...rest } = props;
  const [inputType, setInputType] = useState('password');

  const handlePasswordVisibility = (): void => {
    inputType === 'password' ? setInputType('text') : setInputType('password');
  };

  return (
    <Box
      css={{
        width: inputWidth(width, fullWidth),
      }}
    >
      <FlexBoxStyled>
        <Input error={error} fullWidth id={id} type={inputType} ref={ref} {...rest} />
        <VisibilityContainerStyled data-testid="visibility" onClick={() => handlePasswordVisibility()}>
          {inputType === 'password' ? <VisibilityIconStyled /> : <VisibilityOffIconStyled />}
        </VisibilityContainerStyled>
      </FlexBoxStyled>
      {error != null && !error && <DescriptionStyled>{description}</DescriptionStyled>}
    </Box>
  );
});

InputPassword.displayName = 'InputPassword';

export default InputPassword;
